export default "__VITE_ASSET__3d44bae1__"